var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M932.8 941.6H91.2c-48 0-87.2-39.2-87.2-87.2V769.6c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v84.8c0 48-39.2 87.2-87.2 87.2zM36 785.6v68.8c0 30.4 24.8 55.2 55.2 55.2h841.6c30.4 0 55.2-24.8 55.2-55.2v-68.8H36zM956 710.4H68c-8.8 0-16-7.2-16-16V98.4c0-8.8 7.2-16 16-16h888.8c8.8 0 16 7.2 16 16v596c-0.8 8.8-8 16-16.8 16z m-872-32h856.8V114.4H84v564z",
    fill: "#0E1856"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M884.8 630.4H139.2c-4.8 0-8-3.2-8-8V169.6c0-4.8 3.2-8 8-8h745.6c4.8 0 8 3.2 8 8v452.8c0 4.8-3.2 8-8 8z m-737.6-16h729.6V177.6H147.2v436.8z",
    fill: "#0E1856"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M808.8 256h-62.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h62.4c4.8 0 8 3.2 8 8s-3.2 8-8 8zM808.8 355.2h-62.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h62.4c4.8 0 8 3.2 8 8 0 4-3.2 8-8 8zM808.8 453.6h-62.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h62.4c4.8 0 8 3.2 8 8s-3.2 8-8 8zM808.8 552h-62.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h62.4c4.8 0 8 3.2 8 8s-3.2 8-8 8zM621.6 556.8H537.6c-4.8 0-8-3.2-8-8V314.4h-35.2c-4.8 0-8-3.2-8-8v-63.2c0-4.8 3.2-8 8-8h127.2c4.8 0 8 3.2 8 8v305.6c0 4.8-4 8-8 8z m-76-16h67.2V251.2H502.4v47.2h35.2c4.8 0 8 3.2 8 8v234.4z",
    fill: "#0E1856"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M537.6 556.8H445.6c-4.8 0-8-3.2-8-8V356h-26.4c-4.8 0-8-3.2-8-8v-41.6c0-4.8 3.2-8 8-8h127.2c4.8 0 8 3.2 8 8v242.4c-0.8 4.8-4 8-8.8 8z m-84-16h76.8V314.4H419.2v25.6h26.4c4.8 0 8 3.2 8 8v192.8z",
    fill: "#0E1856"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M445.6 556.8H361.6c-4.8 0-8-3.2-8-8V397.6h-35.2c-4.8 0-8-3.2-8-8v-41.6c0-4.8 3.2-8 8-8h127.2c4.8 0 8 3.2 8 8v200.8c0 4.8-4 8-8 8z m-76-16h67.2V356H326.4v25.6h35.2c4.8 0 8 3.2 8 8v151.2z",
    fill: "#0E1856"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M361.6 556.8H235.2c-4.8 0-8-3.2-8-8V389.6c0-4.8 3.2-8 8-8h127.2c4.8 0 8 3.2 8 8v159.2c-0.8 4.8-4 8-8.8 8z m-118.4-16h111.2V397.6H243.2v143.2z",
    fill: "#0E1856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.c94b84dc64589e9f5564b66a7e1353e1.svg";
export { ForwardRef as ReactComponent };